export default {
    l_welcome_to_nano: 'Welcome on Nano',
    l_nano_punchline: 'Simply useful URL shortener',
    l_generated_urls: 'Generated redirections',
    l_url_address: 'Enter your URL',
    l_shorturls: 'Short URLs',
    l_urls: 'Redirections',
    l_actives: 'Actives',
    l_actions: 'Actions',
    l_no_content_table: 'No redirection at the moment',
    l_check_url: 'Invalid URL',
    l_url_generated_success: 'Redirection successfully created',
    l_delete_url: 'Delete the redirection ?',
    l_confirm_deletion_of_url: 'Please confirm the suppression of the redirection. This cannot be undone.',
    l_yes: 'Confirm',
    l_cancel: 'Cancel',
    l_unable_to_delete_url: 'Unable to remove the URL...',
    l_unable_to_generate_url: 'Unable to generate the URL...',
    l_unable_to_update_active: 'Unable to (de)activate the URL...',
    l_update_ok: 'Redirection successfully updated!',
    l_success: 'Success',
    l_error: 'Error',
    l_loading_please_wait: 'Redirection...',
    l_redirection_in_progress: 'Redirection in progress... Please wait',
    l_oh_no: 'Oh no!',
    l_no_redirection_error: 'Your URL is not valid! Unable to redirect...',
    l_unable_to_copy: 'The copy failed',
    l_copy_ok: 'Your URL has been copied into the clipboard!',
    l_ok: 'Ok',
    l_here_is_the_qrcode: 'Here is the QRCode for the generated link',
};
